export default {
  modelName: 'event_type',
  label: '事件類型',
  fields: {
    area: {
      type: 'belongsTo',
      label: '地區',
      rules: 'required',
      textKey: 'name',
      modelName: 'area',
      clearable: true,
    },
    show_fields: {
      type: 'multi-select',
      label: '顯示欄位',
      items: [
        {
          value: 'improvement_limited_period',
          text: '限期改善',
        },
      ],
    },
    icon: {
      type: 'image',
      label: 'Icon',
      uploadUrl: '/event_type/icon/',
      maxWidth: '100px',
    },
    locales: {
      type: 'locales',
      fields: {
        name: {
          type: 'text',
          label: '名稱',
          autofocus: true,
          rules: 'required',
          maxlength: 30,
        },
      },
    },
    name: {
      type: 'text',
      label: '名稱',
      readonly: true,
    },
    sequence: {
      type: 'text',
      label: '排序',
      maxlength: 10,
    },
    updated_at: {
      type: 'datetime',
      label: '最後更新時間',
      readonly: true,
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
  },
};
